export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const FETCH_PROFILE_FAILED = 'FETCH_PROFILE_FAILED';
export const FETCH_PROFILE_SUCCESS = 'FETCH_PROFILE_SUCCESS';
export const LOGOUT = 'LOGOUT';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILED = 'RESET_PASSWORD_FAILED';

export const login = (credentials) => {
  return {
    type: LOGIN,
    payload: credentials
  }
};

export const loginSuccess = (accessToken) => {
  return {
    type: LOGIN_SUCCESS,
    payload: accessToken
  }
};

export const logout = () => {
  return {
    type: LOGOUT
  }
};

export const fetchProfileFailed = (error) => {
  return {
    type: FETCH_PROFILE_FAILED,
    payload: error,
    error: true,
  }
};

export const fetchProfileSuccess = (profile) => {
  return {
    type: FETCH_PROFILE_SUCCESS,
    payload: profile
  }
};

export const resetPassword = (data) => {
  return {
    type: RESET_PASSWORD,
    payload: data
  }
};

export const resetPasswordSuccess = () => {
  return {
    type: RESET_PASSWORD_SUCCESS,
  }
};

export const resetPasswordFailed = (error) => {
  return {
    type: RESET_PASSWORD_FAILED,
    payload: error,
    error: true,
  }
};


// WEBPACK FOOTER //
// ./src/actions/auth.js